module.exports = __webpack_public_path__ + "static/media/availability-slide-6.15ff12f9.jpg";